import Loadable from '../../components/loadable';

const Recaptcha = Loadable({
  loader: () => import('../../components/recaptcha'),
});

angular.module('shared').value('Recaptcha', Recaptcha);
